

export default window.config as IAppConfig;